// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"dialogmodal_modalContainer__2-B87","btnContainer":"dialogmodal_btnContainer__2BfrW"};